export const NEXT_BUTTON = "NEXT_BUTTON";
